export const formatStatusCodeError = (input?: string) => {
  const backupString =
    'There was an error processing your request. Please try again.';

  if (!input) return backupString;

  if (/\b\d{3}\b/.test(input)) return backupString;

  return input;
};

export const isCheckoutAlreadyPaidError = (errorMessage?: string): boolean => {
  if (!errorMessage) return false;

  const message = errorMessage.toLowerCase();
  return message.includes('checkout has already been paid');
};

export const areCheckoutLinesOutOfStock = (errorMessage?: string): boolean => {
  if (!errorMessage) return false;

  return errorMessage
    .toLowerCase()
    .includes('payment cannot be processed due to out of stock items');
};
